// Third Party library imports
import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'zop-select-tags',
    imports: [
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatChipsModule,
      MatIconModule
    ],
    template: `
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ to.label }}</mat-label>
        <mat-chip-grid #chipGrid>
          <mat-chip *ngFor="let chip of value" [removable]="true" (removed)="remove(chip)">
            {{ chip }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            matInput
            [placeholder]="to.placeholder!"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="add($event)"
          />
        </mat-chip-grid>
      </mat-form-field>
    `,
    styles: [`.full-width { width: 100%; }`]
})
export class SelectTagsComponent extends FieldType<FieldTypeConfig> {
    separatorKeysCodes: number[] = [ENTER, COMMA];

    get value(): string[] {
      return this.formControl.value || [];
    }

    add(event: MatChipInputEvent): void {
      const value = (event.value || '').trim();
      if (value) {
        this.formControl.setValue([...this.value, value]);
      }
      event.chipInput!.clear();
    }

    remove(chip: string): void {
      this.formControl.setValue(this.value.filter(c => c !== chip));
    }
}